import { useCallback, useEffect, useState } from 'react';
import { getReportsPage, ReportSummary } from '../services/reportApi';
import type { PageResponse } from '../types/pagination';

const PAGE_SIZE = 12;

const emptyPage: PageResponse<ReportSummary> = {
  items: [], total: 0, limit: PAGE_SIZE, offset: 0, has_more: false,
};

export function useReportsPage(scope: 'live' | 'paper' = 'live') {
  const [reportsPage, setReportsPage] = useState(emptyPage);
  const [offset, setOffset] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadReports = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getReportsPage({ limit: PAGE_SIZE, offset, startDate, endDate, scope });
      setReportsPage(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : '리포트 조회 실패');
    } finally {
      setLoading(false);
    }
  }, [endDate, offset, scope, startDate]);

  useEffect(() => { loadReports(); }, [loadReports]);

  const search = () => {
    if (offset === 0) loadReports();
    else setOffset(0);
  };

  return {
    reportsPage, offset, startDate, endDate, loading, error,
    setOffset, setStartDate, setEndDate, loadReports, search,
  };
}
